import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SuperImageHistoryItem } from '../components/super-image-studio/super-image-studio.models';

const STORAGE_KEY = 'superImageStudioHistory';

@Injectable({
  providedIn: 'root'
})
export class SuperImageStudioHistoryService {
  private readonly historySubject = new BehaviorSubject<SuperImageHistoryItem[]>(this.loadHistory());
  readonly history$ = this.historySubject.asObservable();

  addHistory(item: SuperImageHistoryItem): void {
    const next = [item, ...this.historySubject.value].slice(0, 24);
    this.historySubject.next(next);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  }

  clearHistory(): void {
    this.historySubject.next([]);
    localStorage.removeItem(STORAGE_KEY);
  }

  private loadHistory(): SuperImageHistoryItem[] {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw) as SuperImageHistoryItem[];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
